import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <h3>DECN德中展会服务</h3>
            <p>您在德国展会的得力助手</p>
          </div>
          {/* Removed footer-links section */}
          <div className="footer-contact">
            <h4>联系方式</h4>
            <p>
              <FontAwesomeIcon icon={faEnvelope} /> <a href="mailto:info@decn-exhibition.top">info@decn-exhibition.top</a>
            </p>
            <p>微信号：LouisNERO</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {currentYear} DECN德中展会服务 - 由德国留学生团队提供的个人服务</p>
          <p className="disclaimer">本服务由个人团队提供，非公司组织</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;